export default __webpack_public_path__ + "static/RTG_PDP_LOGO_CCH_830x100-48bbc570fbf503aedae1d2037f499129.png";